import { RECORD_DATA_TYPE } from '@demandproai/shared';
import { CaseFileUpload } from "../../../../components";
import XLoader from "../../../../components/common/XLoader";
import useRecordFiles from "../../../../hooks/useRecordFiles";
import useRemoveRecord from "../../../../hooks/useRemoveRecord";
import { RECORD_FILE_CONFIG } from "../../../../utils/enum";

const CurriculumVitae = () => {
    const { files, isLoading:isCvLoading, isUploading, uploadFiles, refetch, isUploadPending } = useRecordFiles(null, RECORD_DATA_TYPE.CURRICULUM_VITAE);

    const config = RECORD_FILE_CONFIG[RECORD_DATA_TYPE.CURRICULUM_VITAE];
    const { removeFile } = useRemoveRecord({ successMessage: config?.removeSuccessMessage, onSuccess: refetch });

    return (
        <>
            <div className="title">
                <h2>Curriculum Vitae</h2>
            </div>
            <div className="relative flex flex-col min-w-0 break-words bg-surface border border-border rounded-md mb-12!">
                <div className="row">
                    <div className="col-md-12 mb-6!">
                        {isCvLoading
                            ? <XLoader/>
                            : <CaseFileUpload
                                label='Upload Curriculum Vitae'
                                onFileSelect={uploadFiles}
                                files={files}
                                onRemove={removeFile}
                                isLoading={isUploading || isUploadPending}
                                multiple={true}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default CurriculumVitae;
